import { useEffect } from 'react';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import LoadingIndicatorBase from 'src/components/LoadingIndicator';
import { TermsType, goRecentTerms } from 'src/utils/terms/zendeskApi';
const LoadingIndicator = styled(LoadingIndicatorBase)`
  position: fixed;
  color: ${({
  theme
}) => theme.color.content7};
`;
const LocationBasedTermsView = () => {
  const router = useRouter();
  useEffect(() => {
    if (!router.isReady) return;

    // location based terms는 한국어 문서만 지원함
    // @see https://hpcnt.slack.com/archives/C0ADQS0QZSR/p1773366837280539?thread_ts=1773232916.995069&cid=C0ADQS0QZSR
    const lang = 'ko';
    goRecentTerms(TermsType.locationBasedTerms, lang);
  }, [router.isReady]);
  return <LoadingIndicator size={32} data-sentry-element="LoadingIndicator" data-sentry-component="LocationBasedTermsView" data-sentry-source-file="LocationBasedTerms.tsx" />;
};
export default LocationBasedTermsView;